import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, Typography } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import React, { useMemo } from 'react';
import styles from './FundingOverviewHeader.module.scss';
export const FundingOverviewHeader = React.memo(({ selectedPeriod, onPeriodChange, fundingSummary }) => {
    const { t, formatDateAsUTC } = useLocale();
    const hasLifetimeCap = fundingSummary?.hasLifetimeCap;
    const periodLabel = useMemo(() => {
        if (!fundingSummary?.periodStart || !fundingSummary?.periodEnd) {
            return null;
        }
        return `${formatDateAsUTC(fundingSummary.periodStart, { dateStyle: 'medium' })} - ${formatDateAsUTC(fundingSummary.periodEnd, { dateStyle: 'medium' })}`;
    }, [fundingSummary?.periodStart, fundingSummary?.periodEnd, formatDateAsUTC]);
    const selectOptions = useMemo(() => [
        {
            value: 'CURRENT_YEAR',
            label: periodLabel || t('Current period'),
        },
        { value: 'ALLTIME', label: t('All time') },
    ], [periodLabel, t]);
    return (_jsxs("div", { className: styles.overviewHeader, children: [_jsx(Typography, { variant: 'h2', children: t('Funding overview') }), hasLifetimeCap ? (_jsx("div", { className: styles.selectContainer, children: _jsx(Select, { label: t('Benefit period'), value: selectedPeriod, onChange: onPeriodChange, className: styles.benefitPeriodSelect, options: selectOptions, placeholder: t('Select period...'), isClearable: false }) })) : (periodLabel && (_jsxs(Typography, { variant: 'body2', className: styles.benefitPeriod, children: [t('Benefit period'), ": ", periodLabel] })))] }));
});
FundingOverviewHeader.displayName = 'FundingOverviewHeader';
